import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {planPropTypes} from '../../../../utils/propTypes';

const PlanPrefix = ({plan, isCurrentPlan}) => {
  if (!isCurrentPlan) {
    return (
      <span
        className="information-primary mb-3 font-size-l uppercase"
        style={{textAlign: 'center'}}
      >
        {plan.depositor ?
          <Translate value={'subscriptions.plans.shareDocuments'}/> :
          <Translate value={'subscriptions.plans.collectDocuments'}/>
        }
      </span>
    );
  }

  return (
    <span
      className="information-primary mb-3 font-size-l uppercase"
      style={{textAlign: 'center'}}
    >
      <Translate value={'subscriptions.plans.actualPlan'}/>
    </span>
  );
};

PlanPrefix.propTypes = {
  plan: planPropTypes().isRequired,
  isCurrentPlan: PropTypes.bool.isRequired
};

export default PlanPrefix;
